export default __webpack_public_path__ + "static/media/hbs-cbb-4.371b11d4.png";